<template>
    <div class="yq-penalty-details" v-if="config&&data" v-route-title="getTitle(data)">
        <div class="yq-penalty-title">{{getTitle(data)}}</div>
        <table class="yq-penalty-table">
            <tr>
                <td class="yq-penalty-table-head" width="100">名称：</td>
                <td class="yq-penalty-table-value" width="547">{{data.source[config.title.config.field]}}</td>
                <td class="yq-penalty-table-head" width="100">文号：</td>
                <td class="yq-penalty-table-value">{{data.source[config.docNo.config.field]}}</td>
            </tr>
            <tr>
                <td class="yq-penalty-table-head">处罚机构：</td>
                <td class="yq-penalty-table-value">{{data.source[config.organization.config.field]}}</td>
                <td class="yq-penalty-table-head">处罚类型：</td>
                <td class="yq-penalty-table-value">{{join(data.source[config.type.config.field])}}</td>
            </tr>
            <tr>
                <td class="yq-penalty-table-head">来源站点：</td>
                <td class="yq-penalty-table-value">{{data.source[config.docSite.config.field]}}</td>
                <td class="yq-penalty-table-head">来源栏目：</td>
                <td class="yq-penalty-table-value">{{data.source[config.docChannel.config.field]}}</td>
            </tr>
            <tr>
                <td class="yq-penalty-table-head">处罚公司：</td>
                <td class="yq-penalty-table-value">{{join(data.source[config.targetCompany.config.field])}}</td>
                <td class="yq-penalty-table-head">处罚人：</td>
                <td class="yq-penalty-table-value">{{join(data.source[config.targetPerson.config.field])}}</td>
            </tr>
            <tr>
                <td class="yq-penalty-table-head">相关公司：</td>
                <td class="yq-penalty-table-value">{{join(data.source[config.relatedCompany.config.field])}}</td>
                <td class="yq-penalty-table-head">处罚日期：</td>
                <td class="yq-penalty-table-value">
                    <pretty-date-time :value="data.source[config.penaltyDate.config.field]" format="uuuu-MM-dd"
                                      :value-format="penaltyDateField.dateValueFormat" java-format></pretty-date-time>
                </td>
            </tr>
            <tr>
                <td class="yq-penalty-table-head">违规行为：</td>
                <td class="yq-penalty-table-value" colspan="3">{{data.source[config.irregularities.config.field]}}</td>
            </tr>
            <tr>
                <td class="yq-penalty-table-head">处罚措施：</td>
                <td class="yq-penalty-table-value" colspan="3">{{data.source[config.penalties.config.field]}}</td>
            </tr>
        </table>
        <div class="yq-penalty-foot">
            <a v-if="getUrl(data)" class="yq-penalty-link" :href="getUrl(data)" target="_blank">查看原文</a>
        </div>
    </div>
</template>

<script>
    import preview from '../../assets/images/templates/penalty_list.png'
    import thumbnail from '../../assets/images/templates/penalty_list_thumbnail.png'
    import templateUtils from '../../service/view-template-utils'

    const regions = {
        title: {
            name: '标题',
            config: {
                field: {
                    name: '标题字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        docNo: {
            name: '文号',
            config: {
                field: {
                    name: '文号字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        organization: {
            name: '处罚机构',
            config: {
                field: {
                    name: '处罚机构字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        type: {
            name: '处罚类型',
            config: {
                field: {
                    name: '处罚类型字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        docSite: {
            name: '来源站点',
            config: {
                field: {
                    name: '来源站点字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        docChannel: {
            name: '来源栏目',
            config: {
                field: {
                    name: '来源栏目字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        targetCompany: {
            name: '处罚公司',
            config: {
                field: {
                    name: '处罚公司字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        targetPerson: {
            name: '处罚人员',
            config: {
                field: {
                    name: '处罚人员字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        relatedCompany: {
            name: '相关公司',
            config: {
                field: {
                    name: '相关公司字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        penaltyDate: {
            name: '处罚日期',
            config: {
                field: {
                    name: '处罚日期字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        irregularities: {
            name: '违规行为',
            config: {
                field: {
                    name: '违规行为字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        penalties: {
            name: '处罚措施',
            config: {
                field: {
                    name: '处罚措施字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        docUrl: {
            name: '原文链接',
            config: {
                field: {
                    name: '原文链接字段',
                    required: true,
                    type: 'field'
                },
                field2: {
                    name: '原文链接字段2',
                    required: true,
                    type: 'field'
                }
            }
        },
    }
    export default {
        name: "PenaltyDetails",
        props: {
            config: Object,
            data: Object,
            datasource: Object
        },
        computed: {
            penaltyDateField () {
                return this.datasource.fields.find(field => field.name === this.config.penaltyDate.config.field)
            }
        },
        methods: {
            join(value){
                if(!value){
                    return ''
                }else if(Array.isArray(value)){
                    return value.join('、')
                }else {
                    return value+''
                }
            },
            getTitle(row){
                return row.source[this.config.title.config.field] || (row.source[this.config.organization.config.field] + '（行政处罚信息）')
            },
            getUrl(row){
                return row.source[this.config.docUrl.config.field] || row.source[this.config.docUrl.config.field2]
            }
        }
    }
    function getFields(config){
        const fields = []
        for(const regionKey in config){
            fields.push(config[regionKey].config.field)
            if(regionKey==='docUrl'){
                fields.push(config[regionKey].config.field2)
            }
        }
        return fields
    }
    function validateConfig(config){
        return templateUtils.validateConfig(regions, config)
    }
    export {regions, preview, thumbnail, getFields, validateConfig}
</script>

<style scoped>

</style>
